import identityService from './identityService';
import contentCreationService from './contentCreationService';

const services = [
  {
    serviceName: 'bo-identity-api',
    service: identityService,
  },
  {
    serviceName: 'crm-ft-api-content-creation',
    service: contentCreationService,
  },
];

export default services;
